import { CartDisplayer, CommentSection, CustomBottomBar, CustomPageTitle, DeliveryInfos, DropdownButton } from '@components';
import { Button, Container, Icon, Input, Modal, showToast, Typography } from '@design-system';
import React from 'react';
import { FaStar } from 'react-icons/fa';
import { IoMdMore } from 'react-icons/io';
import './EpiOrderCartPage.scss';
import { EpiOrderCartSkeleton } from './EpiOrderCartSkeleton';
import { useEpiOrderCartPageVM } from './useEpiOrderCartPageVM';

export const EpiOrderCartPage: React.FC = () => {
    const {
        actions,
        order,
        items,
        isLoading,
        removeItem,
        updateQuantity,
        editable,
        handleUpdateOrder,
        selectedWorksiteId,
        comment,
        deliveryDate,
        selectedOperatorId,
        setSelectedWorksiteId,
        setComment,
        setDeliveryDate,
        worksitesOptions,
        operatorsOptions,
        handleOperatorChange,
        handleAddProduct,
        showModal,
        setShowModal,
        cartName,
        setCartName,
        handleSaveCart
    } = useEpiOrderCartPageVM();

    return (
        <div className={`epi-order-cart-page ${isLoading ? 'loading' : ''}`}>
            {isLoading || !items || !order ? (
                <EpiOrderCartSkeleton />
            ) : (
                <>
                    {(items || order) && (
                        <>
                            <CustomPageTitle>
                                <Typography intrinsic="h3">Commande EPI {editable ? 'en cours' : 'passée'}</Typography>
                            </CustomPageTitle>
                            <Container className="epi-order-cart-page-header" padding="medium large" radius="none">
                                <div className="epi-order-cart-page-infos">
                                    <Typography intrinsic="h2">Commande EPI #{order?.id}</Typography>
                                    <Typography intrinsic="p" variant="secondary" color="grey" className="mt-small-spacing">
                                        {order?.products.length}{' '}
                                        {order?.products.length && order?.products.length > 1 ? 'produits' : 'produit'}
                                    </Typography>
                                </div>
                                <DropdownButton icon={<IoMdMore />} actions={items.length > 0 ? actions : []} color="grey" />
                            </Container>

                            <Container className="epi-order-cart-page-content" padding="medium" radius="none">
                                <CartDisplayer
                                    items={items}
                                    onRemoveItem={removeItem}
                                    onUpdateQuantity={updateQuantity}
                                    readOnly={!editable}
                                    onAddProduct={handleAddProduct}
                                    type="epi"
                                />

                                <DeliveryInfos
                                    operatorsOptions={operatorsOptions}
                                    worksitesOptions={worksitesOptions}
                                    selectedOperatorId={selectedOperatorId}
                                    selectedWorksiteId={selectedWorksiteId}
                                    deliveryDate={deliveryDate}
                                    onOperatorChange={handleOperatorChange}
                                    onWorksiteChange={setSelectedWorksiteId}
                                    onDeliveryDateChange={setDeliveryDate}
                                    readOnly={!editable}
                                />

                                <CommentSection comment={comment} onCommentChange={setComment} readOnly={!editable} />
                            </Container>

                            <Modal
                                open={showModal}
                                setClose={() => setShowModal(false)}
                                title="Enregistrer le panier dans les favoris"
                                titleIcon={<Icon icon={<FaStar />} size={20} color="marine" />}
                                footer={
                                    <div className="modal-footer">
                                        <Button
                                            color="grey"
                                            variant="tertiary"
                                            onClick={() => {
                                                setShowModal(false);
                                            }}
                                        >
                                            <Typography intrinsic="h4">Annuler</Typography>
                                        </Button>
                                        <Button
                                            color="green"
                                            variant="secondary"
                                            size="small"
                                            onClick={() => {
                                                if (!cartName) {
                                                    showToast({
                                                        message: 'Veuillez entrer un nom pour le panier',
                                                        type: 'error'
                                                    });
                                                    return;
                                                }
                                                handleSaveCart();
                                            }}
                                        >
                                            <Typography intrinsic="h4">Enregistrer</Typography>
                                        </Button>
                                    </div>
                                }
                            >
                                <Input
                                    placeholder="Nom du panier"
                                    value={cartName}
                                    onValueChange={setCartName}
                                    className="cart-name-input"
                                />
                            </Modal>

                            {editable && (
                                <CustomBottomBar>
                                    <Button color="marine" variant="primary" size="fullwidth" onClick={handleUpdateOrder}>
                                        <Typography intrinsic="h4">Mettre à jour la commande</Typography>
                                    </Button>
                                </CustomBottomBar>
                            )}
                        </>
                    )}
                </>
            )}
        </div>
    );
};
